import React, { useState } from "react"

import { useDispatch, useSelector } from "react-redux"

import { demoDataToggle } from "../redux/user.thunks"

export const useDemoDataToggle = () => {
  const dispatch = useDispatch()
  const { is_show_demo_data } = useSelector((state) => state.auth.userInfo)
  const { demoDataShownToggleLoading: loading } = useSelector((state) => state.user)

  const toggleDemoData = () => {
    dispatch(demoDataToggle(!is_show_demo_data))
  }

  return { isShowDemoData: is_show_demo_data, toggleDemoData, loading }
}
